// extracted by mini-css-extract-plugin
export default {"input":"SignUpBusinessForm_input__pbZmQ","errored":"SignUpBusinessForm_errored__kPDXp","error":"SignUpBusinessForm_error__+XxyY","grid":"SignUpBusinessForm_grid__uxFHp"};